import { useState } from 'react';
import axios from 'axios';
import config from '../config';
import { useQuery, useIsFetching } from 'react-query';

export default function useStudents() {
  const [noResults, setNoResults] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [page, setPage] = useState(1);
  const isFetching = useIsFetching();

  // API CALL
  const { data } = useQuery(
    ['students', searchString, page],
    async () => {
      const formData = new FormData();
      formData.append('auth', localStorage.getItem('token'));
      if (searchString) {
        setPage(1);
        formData.append('mode', 'studentSearch');
        formData.append(
          'searchOptions',
          document.getElementById('searchPredicate').value
        );
        formData.append('searchString', searchString);
      }
      const output = await axios.post(
        config.STUDENTS_API + '/' + page,
        formData
      );
      if (output.data.response.status === 'OK') {
        // NORMAL RESULTS OUTPUT
        setNoResults(false);
        return output.data.response;
      } else {
        // EMPTY RESULTS
        setNoResults(true);
        return [];
      }
    },
    {
      keepPreviousData: true,
    }
  );

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handlePageChange = (e, v) => {
    setPage(v);
  };

  return {
    isFetching,
    setSearchString,
    data,
    noResults,
    page,
    openDialog,
    handleClose,
    handlePageChange,
  };
}
